/**
 * Figures are rounded here rather than on the server.
 *
 * The totals are sums of doubles, so one arrives as 1234.5600000000002; that
 * figure on a slide in front of a facilities director reads as a broken
 * report. They are estimates a poster typed in the first place, so the whole
 * unit is the honest precision. The CSV downloads still carry the stored
 * numbers.
 */
const WHOLE = { maximumFractionDigits: 0 };

export const whole = (value) =>
    Number(value || 0).toLocaleString('en-US', WHOLE);
export const money = (value) => `$${whole(value)}`;
export const pounds = (value) => `${whole(value)} lb`;

const MONTH_FORMAT = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
});

/** `2026-03` as `Mar 2026`. The key is a month, so it is read as UTC. */
export function monthLabel(key) {
    const [year, month] = key.split('-').map(Number);
    return MONTH_FORMAT.format(new Date(Date.UTC(year, month - 1, 1)));
}
